import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";
import BooleanField from "./BooleanField";
import { valueOrEmpty } from "../tools";
import CopyLinkButton from "./CopyLinkButton";
import { Invitation } from "../types";
import { INVITATION_TYPE_MESSAGES } from "conference/messages";

const Row = ({ invitation }: { invitation: Invitation }) => (
    <TableRow>
        <TableCell>{valueOrEmpty(invitation.name)}</TableCell>
        <TableCell>{valueOrEmpty(invitation.phoneNumber)}</TableCell>
        <TableCell>{valueOrEmpty(invitation.email)}</TableCell>
        <TableCell>
            <FormattedMessage {...INVITATION_TYPE_MESSAGES[invitation.type]} />
        </TableCell>
        <TableCell align="center">
            <BooleanField value={invitation.pinCodeRequired} />
        </TableCell>
        <TableCell align="center">
            <BooleanField value={invitation.callout} />
        </TableCell>
        <TableCell>
            <CopyLinkButton url={invitation.joinUrl} />
        </TableCell>
    </TableRow>
);

export default ({ invitations }: { invitations: Invitation[] }) => {
    return (
        <div style={{ width: "100%", overflowX: "auto" }}>
            <Table style={{ width: "100%" }}>
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <Typography>
                                <FormattedMessage id="name" defaultMessage="Name" />
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography>
                                <FormattedMessage id="phoneNumber" defaultMessage="Phone number" />
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography>
                                <FormattedMessage id="email" defaultMessage="Email address" />
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography>
                                <FormattedMessage id="type" defaultMessage="Type" />
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography>
                                <FormattedMessage id="pinCode.required.bool" defaultMessage="PIN" />
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography>
                                <FormattedMessage id="callout" defaultMessage="Callout" />
                            </Typography>
                        </TableCell>
                        <TableCell />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {invitations.map((invitation) => (
                        <Row key={invitation.id} invitation={invitation} />
                    ))}
                </TableBody>
            </Table>
        </div>
    );
};
